<template>
  <MenuBar>

    <template v-if="selectedTag">
      <div class="tag-edit-bar level is-gapless is-vcentered is-glassy">
        <div class="level-item has-text-centered">
          <h1 v-if="editingTagName !== ' '">
            <b-icon icon="hashtag" /> {{ editingTagName }}
          </h1>
        </div>

        <div
          v-if="editingTagName !== ' '"
          class="level-right"
        >
          <b-button
            class="menubar-button danger"
            title="Delete"
            @click="isDeleteModalActive = true"
          >
            <b-icon
              icon="trash-alt"
              size="is-small"
            />
            <span
              class="is-hidden-mobile"
              style="margin-left: 8px"
            >Delete</span>
          </b-button>
          <b-button
            class="menubar-button "
            title="Rename"
            @click="isRenameModalActive = true; editTagTo = editingTagName"
          >
            <b-icon
              icon="pencil-alt"
              size="is-small"
            />
            <span
              class="is-hidden-mobile"
              style="margin-left: 8px"
            >Rename</span>
          </b-button>
        </div>
      </div>

      <b-modal
        v-model="isRenameModalActive"
        has-modal-card
        trap-focus
        scroll="keep"
        destroy-on-hide
      >
        <template>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ mergingOrRenaming }}
              </p>
            </header>
            <section
              class="modal-card-body"
              style="min-height: 15em;"
            >
              <b-autocomplete
                v-model="editTagTo"
                ref="editTagInput"
                icon="hashtag"
                :data="filteredTags"
                field="name"
                clearable
                @select="tag => { tag ? editTagTo = tag.name : '';}"
              >
              </b-autocomplete>
            </section>
            <footer class="modal-card-foot">
              <b-button
                :label="mergingOrRenaming"
                expanded
                type="is-primary"
                :disabled="!editTagTo || editTagTo.length < 2 || editTagTo === editingTagName"
                @click="editTag()"
              />
            </footer>
          </div>
        </template>
      </b-modal>

      <b-modal
        v-model="isDeleteModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
      >
        <template>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                And the underlying bookmarks?
              </p>
            </header>
            <section class="modal-card-body">
              <b-field>
                <b-radio
                  v-model="cascadeType"
                  name="name"
                  native-value="None"
                  type="is-info"
                >
                  Keep them, leave single-tagged ones with #{{ editingTagName }} untagged.
                </b-radio>
              </b-field>
              <b-field>
                <b-radio
                  v-model="cascadeType"
                  name="name"
                  native-value="DeleteOrphan"
                  type="is-dark"
                >
                  Delete the single-tagged ones with #{{ editingTagName }}, leave the ramaining ones.
                </b-radio>
              </b-field>
              <b-field>
                <b-radio
                  v-model="cascadeType"
                  name="name"
                  native-value="Delete"
                  type="is-danger"
                >
                  Delete them all.
                </b-radio>
              </b-field>
            </section>
            <footer class="modal-card-foot">
              <b-button
                label="Delete"
                type="is-danger"
                expanded
                @click="deleteTag()"
              />
            </footer>
          </div>
        </template>
      </b-modal>
      </template>
  </MenuBar>
</template>
  
  <script>
    import MenuBar from "@/views/_globals/MenuBar.vue"
    import { mapActions } from 'vuex'
    
    export default {
      name: 'TagEdit',
      components: {
        MenuBar
      },
      props: {
        editingTagName: {
          type: String,
          default: undefined
        },
        existingTags: {
          type: Array,
          default: function(){ return [];}
        }
      },
      data() {
          return {
            isDeleteModalActive: false,
            isRenameModalActive: false,
            cascadeType: "None",
            editTagTo: null
          }
      },
      computed: {
        filteredTags() {
            return this.existingTags && this.existingTags.filter((tag) => {
                return this.editTagTo && 
                        tag.id > 0 && 
                        tag.name !== this.editingTagName 
                        && tag.name
                              .toLowerCase() 
                              .indexOf(this.editTagTo.toLowerCase()) >= 0
            })
        },
        mergingOrRenaming: function(){
          const merging = this.editTagTo && 
                          this.editTagTo !== this.editingTagName &&
                          this.existingTags.filter((tag) => {
                            return  tag.name === this.editTagTo
                          }).length 
          return merging ? 'Merge' : 'Rename';
        }
      },
      methods: {
        ...mapActions({
            deleteDo: 'tags/delete',
            rename: 'tags/rename'
        }),
        deleteTag: function() {
          const _this = this; 
          this.deleteDo({name: this.editingTagName, cascadeType: this.cascadeType}).then((response) => {
            _this.isDeleteModalActive = false;
            if(response){
              _this.$emit("tagDeleted");
            }
          });
          return;
        },
        editTag: function() {
          const _this = this; 
          this.isRenameModalActive = false;
          this.rename({from: this.editingTagName, to: this.editTagTo}).then((response) => {
            if(response){
              _this.$emit("tagRenamed", {to: _this.editTagTo});
              _this.editTagTo = undefined;
            }
          });
          return;
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .tag-edit-bar{
      min-height: 2.5em;
      .menubar-button {
          background: #ffffffab;
          border-color: transparent;
          color: #485fc7;
          text-decoration: none;

          &:hover {
          background: #f0f0f0ab;
          border-color: transparent;
          color: #485fc7;
          text-decoration: none;
          }
          &.danger {
            color: #E15554;
            &:hover {
              color: #E15554;
            }
          }
      }
    }
  </style>